import {
    List,
    Datagrid,
    TextField as TextFieldRa,
    Create,
    SimpleForm,
    TextInput,
    EditButton,
    Show,
    Edit,
    Filter,
    SearchInput,
    ShowButton,
    SelectInput,
    BooleanField,
    BooleanInput,
    NumberInput,
    FormDataConsumer,
    TabbedShowLayout,
    Tab as TabRa,
    ReferenceManyField,
    TopToolbar,
    DeleteButton,
    useShowController,
    useListContext,
} from 'react-admin'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button, Divider, Tab, Tabs } from '@material-ui/core'
import BusinessIcon from '@mui/icons-material/Business'

export const EnterpriseIcon = BusinessIcon

const EnterpriseFilter = (props) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <TextInput label="Cnpj" source="cnpj" />
        <TextInput label="Email" source="email" />
        <TextInput label="Id" source="id" />
    </Filter>
)

const issuerTabs = [
    { id: 'true', name: 'Emissoras' },
    { id: 'false', name: 'Não Emissoras' },
]

const TabbedDatagrid = () => {
    const { filterValues, setFilters, displayedFilters } = useListContext()
    const hasIssuerFilter =
        filterValues.issuer !== undefined && filterValues.issuer !== null

    // filtros salvos de antes das abas podem vir sem issuer
    useEffect(() => {
        if (!hasIssuerFilter) {
            setFilters({ ...filterValues, issuer: true }, displayedFilters)
        }
    }, [hasIssuerFilter, filterValues, setFilters, displayedFilters])

    const handleChange = (event, value) => {
        setFilters(
            { ...filterValues, issuer: value === 'true' },
            displayedFilters
        )
    }

    return (
        <>
            <Tabs
                variant="fullWidth"
                centered
                value={hasIssuerFilter ? String(filterValues.issuer) : 'true'}
                indicatorColor="primary"
                onChange={handleChange}
            >
                {issuerTabs.map((tab) => (
                    <Tab key={tab.id} label={tab.name} value={tab.id} />
                ))}
            </Tabs>
            <Divider />
            <Datagrid>
                <TextFieldRa source="id" label="Id" />
                <TextFieldRa source="corporateName" label="Razão Social" />
                <TextFieldRa source="cnpj" label="Cnpj" />
                <TextFieldRa source="email" label="E-Mail" />
                <TextFieldRa source="state" label="Estado" />
                <TextFieldRa source="city" label="Cidade" />
                <TextFieldRa source="status" label="Status" />
                <EditButton label="" />
                <ShowButton label="" />
            </Datagrid>
        </>
    )
}

export const EnterpriseList = (props) => {
    return (
        <>
            <List
                {...props}
                exporter={false}
                title="Lista de Empresas"
                bulkActionButtons={false}
                sort={{ field: 'id', order: 'DESC' }}
                filters={<EnterpriseFilter />}
                filterDefaultValues={{ issuer: true }}
            >
                <TabbedDatagrid />
            </List>
        </>
    )
}

export const EnterpriseCreate = (props) => {
    return (
        <>
            <Create {...props}>
                <SimpleForm redirect="list">
                    <TextInput
                        label="Razão Social"
                        source="corporateName"
                        required
                    />
                    <TextInput label="CNPJ" source="cnpj" required />
                    <TextInput label="E-mail" source="email" required />
                    <TextInput label="Telefone" source="phone" required />
                    <TextInput label="CEP" source="postalCode" required />
                    <TextInput label="Endereço" source="address" required />
                    <TextInput label="Número" source="addressNumber" required />
                    <TextInput label="Complemento" source="addressComplement" />
                    <TextInput label="Bairro" source="neighborhood" required />
                    <TextInput label="Cidade" source="city" required />
                    <TextInput label="Estado" source="state" required />
                    <TextInput label="Observação" source="note" />
                    <TextInput label="Código Gate" source="codGate" />
                    <BooleanInput
                        label="Acompanhar mesmo preço B2C"
                        source="samePriceB2c"
                    />
                    <FormDataConsumer>
                        {({ formData }) =>
                            !formData.samePriceB2c && (
                                <>
                                    <NumberInput
                                        label="Markup %"
                                        source="markup"
                                    />
                                    <BooleanInput
                                        label="Markup Produto"
                                        source="netTariff"
                                    />
                                </>
                            )
                        }
                    </FormDataConsumer>
                    <BooleanInput
                        label="Permitir emissão manual (Erro de reserva)"
                        source="allowManualIssuance"
                    />
                    <BooleanInput label="Emissora" source="issuer" />
                </SimpleForm>
            </Create>
        </>
    )
}

export const EnterpriseEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput
                    label="Razão Social"
                    source="corporateName"
                    required
                />
                <TextInput label="CNPJ" source="cnpj" required />
                <TextInput label="E-mail" source="email" required />
                <TextInput label="Telefone" source="phone" required />
                <TextInput label="CEP" source="postalCode" required />
                <TextInput label="Endereço" source="address" required />
                <TextInput label="Número" source="addressNumber" required />
                <TextInput label="Complemento" source="addressComplement" />
                <TextInput label="Bairro" source="neighborhood" required />
                <TextInput label="Cidade" source="city" required />
                <TextInput label="Estado" source="state" required />
                <TextInput label="Observação" source="note" />
                <TextInput label="Código Gate" source="codGate" />
                <BooleanInput
                    label="Acompanhar mesmo preço B2C"
                    source="samePriceB2c"
                />
                <FormDataConsumer>
                    {({ formData }) =>
                        !formData.samePriceB2c && (
                            <>
                                <NumberInput label="Markup %" source="markup" />
                                <BooleanInput
                                    label="Markup Produto"
                                    source="netTariff"
                                />
                            </>
                        )
                    }
                </FormDataConsumer>
                <BooleanInput
                    label="Permitir emissão manual (Erro de reserva) "
                    source="allowManualIssuance"
                />
                <BooleanInput label="Emissora" source="issuer" />
                <SelectInput
                    label="Status"
                    source="status"
                    choices={[
                        { id: 0, name: 'Desativado' },
                        { id: 1, name: 'Ativado' },
                    ]}
                />
            </SimpleForm>
        </Edit>
    )
}

export const EnterpriseShow = (props) => {
    const { record } = useShowController(props)

    if (!record) return null

    return (
        <Show {...props}>
            <TabbedShowLayout>
                <TabRa label="Empresa">
                    <TextFieldRa label="Razão Social" source="corporateName" />
                    <TextFieldRa label="CNPJ" source="cnpj" />
                    <TextFieldRa label="E-mail" source="email" />
                    <TextFieldRa label="Telefone" source="phone" />
                    <TextFieldRa label="CEP" source="postalCode" />
                    <TextFieldRa label="Endereço" source="address" />
                    <TextFieldRa label="Número" source="addressNumber" />
                    <TextFieldRa label="Complemento" source="addressComplement" />
                    <TextFieldRa label="Bairro" source="neighborhood" />
                    <TextFieldRa label="Cidade" source="city" />
                    <TextFieldRa label="Estado" source="state" />
                    <TextFieldRa label="Observação" source="note" />
                    <TextFieldRa label="Código Gate" source="codGate" />
                    <TextFieldRa label="Status" source="status" />
                    <BooleanField
                        label="Acompanhar mesmo preço B2C"
                        source="samePriceB2c"
                    />
                    <TextFieldRa label="Markup" source="markup" />
                    <BooleanField label="Markup Produto" source="netTariff" />
                </TabRa>

                <TabRa label="Produtos vinculados">
                    <ReferenceManyField
                        reference="admin/enterpriseProducts"
                        target="enterpriseId"
                        addLabel={false}
                        sort={{ field: 'id', order: 'DESC' }}
                        perPage={100}
                    >
                        <>
                            <TopToolbar>
                                <Button
                                    component={Link}
                                    variant="contained"
                                    to={{
                                        pathname: `/admin/enterpriseProducts/create`,
                                        state: { enterpriseId: record.id },
                                    }}
                                    color="primary"
                                >
                                    Vincular Produto
                                </Button>
                            </TopToolbar>
                            <Datagrid rowClick="show">
                                <TextFieldRa label="Produto" source="Product.name" />
                                <TextFieldRa
                                    label="Nome (Provedor)"
                                    source="Product.providerName"
                                />
                                <TextFieldRa label="Código Tarifa" source="fareCode" />
                                <TextFieldRa label="Markup" source="markup" />
                                <BooleanField label="Ativo" source="active" />
                                <ShowButton label="Tarifas" />
                                <EditButton label="" />
                                <DeleteButton
                                    label=""
                                    redirect={false}
                                    mutationMode="pessimistic"
                                    confirmTitle="Remover vínculo"
                                    confirmContent="As tarifas deste vínculo também serão removidas. Deseja continuar?"
                                />
                            </Datagrid>
                        </>
                    </ReferenceManyField>
                </TabRa>
            </TabbedShowLayout>
        </Show>
    )
}
